import { Component, Input } from '@angular/core';
import { OrderSummaryComponent } from '@spartacus/cart/base/components';
import { isEmpty } from '../../../../../../../core/services/simple-tools';

@Component({
  selector: 'cx-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrl: './order-summary.component.scss',
  standalone: false,
})
export class CustomOrderSummaryComponent extends OrderSummaryComponent {
  @Input() isOrder = false;

  hasDiscount(cart: any) {
    return cart.totalDiscounts?.value > 0;
  }

  showDeliveryCoast(value: any) {
    return !isEmpty(value);
  }
}
